import React from "react";
import { UIFlightData } from "@flights/types";
import { getCampaignBadgesConfig } from "../../../../utils/flightCampaignConfig";
import { FlightCardBadge } from "./FlightCardBadge";
import { Stack } from "@bookingcom/bui-react";

const FlightCardCampaignBadgesList = ({ flight }: { flight: UIFlightData }) => {
  const campaignBadges = getCampaignBadgesConfig(flight.campaignDisplay?.badges);

  if (campaignBadges.length === 0) {
    return undefined;
  }

  return (
    <Stack direction="row" gap={1} alignItems="center" justifyContent="end">
      {campaignBadges.map((badge, idx) => (
        <FlightCardBadge
          key={`keyCampaignBadge-${idx}`}
          alternative={false}
          isInteractive={false}
          flightToken={flight.token}
          {...badge}
        />
      ))}
    </Stack>
  );
};

export default FlightCardCampaignBadgesList;
